/**
 * GMBFailures represents the Failures that GMR API can return on a Google review site error property.
 */

export enum GMBFailures {
    AuthFailure = "Token has been expired or revoked.",
    SentAuthFailure = "Sent re authorization email notification"
}
/**
 * FacebookFailures represents the Failures that GMR API can return on a Facebook review site error property.
 */

export enum FacebookFailures {
    AuthFailure = "Facebook Token has been expired or revoked.",
    PermissionFailure = "Not necessary permissions",
    SentAuthFailure = "Sent re authorization email notification"
}